import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  emptyMonthText: {
    fontSize: 25,
    fontWeight: '300',
  },
  monthTitleText: {
    textAlign: 'center',
    paddingVertical: 10,
  },
});
